import ApiNode from "./ApiNode";

export default {
    getSummaryData(params = {}) {
        return ApiNode().get("vehicle-performance/summary-data", {
            params,
        });
    },
    getUtilizationData(params = {}) {
        return ApiNode().get("vehicle-performance/utilization-data", {
            params,
        });
    },
    getUtilizationTripDetails(params = {}) {
        return ApiNode().get("vehicle-performance/utilization-trip-details", {
            params,
        });
    },
    getUtilizationAssignmentDetails(params = {}) {
        return ApiNode().get("vehicle-performance/utilization-assignment-details", {
            params,
        });
    },
    getMostUsedVehicles(params = {}) {
        return ApiNode().get("vehicle-performance/most-used", {
            params,
        });
    },
    getIdleVehicles(params = {}) {
        return ApiNode().get("vehicle-performance/idle-vehicles", {
            params,
        });
    },
    getRevenueBreakdown(dimension, params = {}) {
        return ApiNode().get(`vehicle-performance/revenue-by-${dimension.replace(/([A-Z])/g, '-$1').toLowerCase()}`, {
            params,
        });
    },
    getExpenseBreakdown(dimension, params = {}) {
        return ApiNode().get(`vehicle-performance/expense-by-${dimension.replace(/([A-Z])/g, '-$1').toLowerCase()}`, {
            params,
        });
    },
    getRevenueVsExpenseTrend(params = {}) {
        return ApiNode().get("vehicle-performance/revenue-vs-expense-trend", {
            params,
        });
    },
    getExpenseCategoryBreakdown(params = {}) {
        return ApiNode().get("vehicle-performance/expense-category-breakdown", {
            params,
        });
    },
    getVehicleMasterList() {
        return ApiNode().get("vehicle-performance/master-list");
    },
    getVehicleMasterDetails(vehicleTruckId) {
        return ApiNode().get(`vehicle-performance/vehicle-master-details/${vehicleTruckId}`);
    },
    getTripVolumeTrends(params = {}) {
        return ApiNode().get("vehicle-performance/trip-volume-trends", { params });
    },
    getAvailabilityData(params = {}) {
        return ApiNode().get("vehicle-performance/availability-data", { params });
    },
    getVehicleTripActivity(params = {}) {
        return ApiNode().get("vehicle-performance/vehicle-trip-activity", { params });
    },
    getTransportAccountingAudit(params = {}) {
        return ApiNode().get("vehicle-performance/transport-accounting-audit", { params });
    },
    getFuelEfficiencyTrend(params = {}) {
        return ApiNode().get("vehicle-performance/fuel-efficiency-trend", { params });
    },
    getLocationIntelligence(startDate, endDate, locationRole) {
        return ApiNode().get("vehicle-performance/location-intelligence", { params: { startDate, endDate, locationRole } });
    },
    getMaintenanceHistory(params = {}) {
        return ApiNode().get("vehicle-performance/maintenance-history", { params });
    },
    getMaintenanceItemBrief(params = {}) {
        return ApiNode().get("vehicle-performance/maintenance-item-brief", { params });
    },
};



// WEBPACK FOOTER //
// ./src/services/VehiclePerformanceService.js